import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { BOX_TYPES } from './box.values';

@Component({
  name: 'ed-inline-msg-box'
})
class EdInlineMsgBox extends Vue {
  
  /* Arguments */
  @Prop() readonly type: BOX_TYPES;
  @Prop({default:'true'}) readonly outline: string;

  /* Data */

  /* Computed */
  get typeNumber(){
    switch (this.type) {
      case BOX_TYPES.SUCCESS:
        return 1
        break;
      case BOX_TYPES.DANGER:
        return 2
        break;
      case BOX_TYPES.WARNING:
        return 3
        break;
      default:
        return 0
        break;
    }
  }

  /* Hooks */
} 

export default Vue.component('ed-inline-msg-box', EdInlineMsgBox);